import React from 'react'
import PropTypes from 'prop-types'

import SearchIcon from '@mui/icons-material/Search'
import ClearIcon from '@mui/icons-material/Clear'
import Input from '@mui/material/Input'
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'

import { styled } from '@mui/material/styles'
import { Theme } from '@mui/material/styles'

type MikeTheme = Theme & {
  palette: Theme['palette'] & {
    devider?: { default: string }
  }
}

const StyledSearchField = styled(Input)(({ theme }) => {
  const t = theme as MikeTheme
  return {
    padding: theme.spacing(1 / 4, 2),
    width: 320,
    height: 40,
    backgroundColor: theme.palette.background.paper,
    borderRadius: '25px',
    border: '1px solid ' + (t.palette.devider?.default ?? theme.palette.divider)
  }
})

const useTextChange = onTextChange => [
  event => onTextChange(event.target.value),
  () => onTextChange('')
]

const SearchInput = ({ text, onTextChange, ...inputProps }) => {
  const [handleTextChange, resetTextChange] = useTextChange(onTextChange)

  return (
    <StyledSearchField
      {...inputProps}
      disableUnderline={true}
      value={text}
      onChange={handleTextChange}
      autoComplete={'off'}
      startAdornment={
        <InputAdornment position="start">
          <SearchIcon />
        </InputAdornment>
      }
      endAdornment={
        text && (
          <InputAdornment position="end">
            <IconButton onClick={resetTextChange} size="large">
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        )
      }
    />
  )
}
SearchInput.propTypes = {
  text: PropTypes.string,
  onTextChange: PropTypes.func
}

export default SearchInput
